import { Settings } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import ScheduleRoute from "../schedule/ScheduleRoute";

import { useSessionContext } from "../../contexts/SessionContext";

export function useScheduleManager() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access.type === "professional",
    path: "/schedule",
    icon: Settings,
    text: "Gerenciar agenda",

    subitem: true,
    parent: "Agendas",

    sideMenu: true,
    sideMenuIndex: 0,

    component: () => <ScheduleRoute />,
  };

  return configs;
}
